import Tourguide from "tourguidejs/tourguide.esm.js"

import "tourguidejs/tourguide.css"

// TODO: Remove?
const TOUR_STEPS = [
  {
    selector: "#nav-menu",
    step: 1,
    title: "Navigation",
    content: `
        Meetings are all public governance meetings; assignments are paid activities
        Documenters can apply to; and workshops are free and required for assignment
        eligibility.
      `,
  },
  {
    selector: "input[name='search']",
    step: 2,
    title: "Search",
    content:
      "Type keywords, the name of a meeting or agency to search results.",
  },
  {
    selector: "section[role='search']",
    step: 3,
    title: "Filter",
    content: "You can also filter results by time, location, and topic.",
  },
  {
    selector: "#filter-result-column",
    step: 4,
    title: "Results",
    content:
      "All results are displayed in this column, starting from today and into the future.",
  },
  {
    selector: "[data-section='time-toggle']",
    step: 5,
    title: "Toggle",
    content:
      "You can toggle the type of results you see by selecting options here, if available.",
  },
  {
    selector: "[data-section='filter-results']",
    step: 6,
    title: "Rows",
    content: `
        Click any row item to see more meeting, assignment and training details and
        documents (if available).`,
  },
  {
    selector: "[aria-controls='area-switcher-menu']",
    step: 7,
    title: "Areas",
    content:
      "Select an area from the area switcher to pre-filter all results by location",
  },
]

export default function Tour(button, steps = TOUR_STEPS) {
  const tourguide = new Tourguide({
    steps,
    onStep: (step) => {
      if (window.gtag) {
        window.gtag("event", "tour", {
          event_category: window.location.pathname,
          event_label: `Step ${step.index}`,
          anonymize_ip: true,
        })
      }

      if (step.index === 6) {
        const row = document.querySelector(step.selector)
        if (!row || !row.getAttribute("aria-controls")) return
        row.click()
      }
    },
  })
  button.addEventListener("click", (e) => {
    e.stopPropagation()
    if (window.gtag) {
      window.gtag("event", "tour", {
        event_category: window.location.pathname,
        event_label: "Start",
        anonymize_ip: true,
      })
    }
    tourguide.start()
  })
}
